import React, { useState } from 'react';
import { X, RefreshCw, ShieldCheck } from 'lucide-react';
import toast from 'react-hot-toast';
import api from './axiosConfig';

const ReorderModal = ({ isOpen, onClose, data, onComplete }) => {
  const [rop, setRop] = useState(data?.reorderpoint || 0);
  const [safety, setSafety] = useState(data?.safetystock || 0);
  const [isSaving, setIsSaving] = useState(false);

  if (!isOpen) return null;

  const handleSave = async () => {
    setIsSaving(true);
    try {
      await api.post('/inventory/reorder-update', {
        record_id: `${data.itemnum}-${data.location}`,
        new_rop: parseFloat(rop),
        new_safety_stock: parseFloat(safety)
      });
      toast.success("Reorder parameters updated!");
      if (onComplete) onComplete();
      onClose();
    } catch (err) {
      toast.error("Update failed");
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-[7000]">
      <div className="bg-white w-[400px] rounded shadow-2xl border border-gray-200 overflow-hidden animate-in zoom-in-95">
        {/* Header */}
        <div className="bg-[#005495] p-4 text-white flex justify-between items-center">
          <div className="flex items-center gap-2">
            <RefreshCw size={16} className={isSaving ? "animate-spin" : ""} />
            <span className="font-black text-[10px] uppercase tracking-widest">Set Reorder Point</span>
          </div>
          <button onClick={onClose} className="hover:rotate-90 transition-transform"><X size={18}/></button>
        </div>

        <div className="p-6 space-y-4">
          {/* Info Box */}
          <div className="bg-blue-50 p-3 rounded text-[10px] font-bold text-blue-700 border-l-4 border-blue-500">
            ITEM: {data.itemnum} | STORE: {data.location}
          </div>

          {/* ROP Input */}
          <div className="space-y-1">
            <label className="text-[9px] font-black text-gray-400 uppercase tracking-widest">Reorder Point (Quantity)</label>
            <input 
              type="number" 
              className="w-full p-3 border-2 border-gray-100 focus:border-blue-500 outline-none font-black text-blue-900 transition-all"
              value={rop}
              onChange={(e) => setRop(e.target.value)}
            />
          </div>

          {/* Safety Stock Input */}
          <div className="space-y-1">
            <label className="text-[9px] font-black text-gray-400 uppercase tracking-widest">Safety Stock (Minimum)</label>
            <input 
              type="number" 
              className="w-full p-3 border-2 border-gray-100 focus:border-blue-500 outline-none font-black text-blue-900 transition-all"
              value={safety}
              onChange={(e) => setSafety(e.target.value)}
            />
          </div>
        </div>

        <div className="p-4 bg-gray-50 flex justify-end gap-3 border-t">
          <button onClick={onClose} className="text-[10px] font-bold text-gray-400 uppercase">Cancel</button>
          <button 
            onClick={handleSave}
            disabled={isSaving}
            className="bg-[#005495] text-white px-8 py-2 rounded shadow-lg font-black text-[10px] uppercase hover:bg-blue-800 transition-all flex items-center gap-2"
          >
            {isSaving ? "Saving..." : "Apply Changes"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReorderModal;